import { useContext, useEffect } from "react";
import { AdAuthGuardResult } from "../Guards";
import SsoService, { ISsoService } from "../../../services/SsoService";
import { RdContextType } from "../../../@types/Rd";
import RdContext from "../../../contexts/RdProvider";
import { useIsAuthenticated, WithMsalProps } from "@azure/msal-react";
import { InteractionRequiredAuthError, InteractionStatus, InteractionType } from "@azure/msal-browser";
import { IsValidToken } from "../../../Hooks/useJwtToken";

export const AdAuthGuard = (props: WithMsalProps): AdAuthGuardResult => {

    const service: ISsoService = new SsoService(props.msalContext),
        { accounts, inProgress, instance, logger } = props.msalContext,
        { AdToken, UpdateAdAccountInfo, UpdateAdToken, Logout } = useContext<RdContextType>(RdContext),
        isAuthenticated = useIsAuthenticated(),
        login = (): void => {
            service.LoginCallBack(InteractionType.Redirect,
                (authResp) => {

                    if (authResp == null) {
                        getToken();
                        return;
                    }

                    UpdateAdAccountInfo && UpdateAdAccountInfo(authResp.account);
                    UpdateAdToken && UpdateAdToken(authResp.accessToken);

                });
        },
        getToken = (): void => {
            UpdateAdAccountInfo && UpdateAdAccountInfo(service.GetAccountInfo());
            const result = service.GetToken(UpdateAdToken,
                error => {
                    if (error instanceof InteractionRequiredAuthError) {
                        // Logout && Logout(InteractionType.Redirect);
                        login();
                    }
                });
        };

    useEffect(() => {
        if (inProgress == InteractionStatus.None) {

            if (!isAuthenticated)
                login();
            else
                getToken();
        }
    }, [inProgress, isAuthenticated]);

    return {
        AdAuthProgress: inProgress,
        isAdAuthenticated: isAuthenticated,
        IsValidToken: IsValidToken(AdToken)
    } as AdAuthGuardResult
};